<fragment>
    <input ref="onlineEditor" type="hidden" name="online_editor" id="onlineEditor"/>
    <input ref="steckdosenEditor" type="hidden" name="steckdosen_editor" id="steckdosenEditor"/>
</fragment>